/**
 * A day, day first, with its year only when it is not this year's: "Sun 15
 * Nov" in 2026, "Sun 3 Jan 2027" seen from 2026. For short notices about
 * days close to today (a due date, the day someone answered), where this
 * year's dates read better without the year. `today` is the group's
 * (America/Toronto), as the server sends it. Pure.
 */
import { yearOf, type ISODate } from '../dates/iso.ts';
import { formatDay, formatDayYear } from './dates.ts';

export function formatDayNear(date: ISODate, today: ISODate): string {
  return yearOf(date) === yearOf(today) ? formatDay(date) : formatDayYear(date);
}
